<header>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@600&display=swap" rel="stylesheet">
  <!-- Barra superior -->
  <div class="navbar top-bar">
    <div class="left-section">
      <a href="/localizacion/localizacion-instantanea/" target="_blank" rel="noopener" class="logo">
        <img src="./logo.png">
      </a>
    </div>
  </div>

  <!-- Barra inferior con pestañas -->
  <div class="navbar bottom-bar">
    <div class="menu">Analítica de datos</div>
    <nav class="tabs">
      <a href="#" class="tab active">Paradas de emergencia</a>
    </nav>
  </div>
</header>
<body>
  <div class="new-modulo-container">
    <app-quicksight [context]="'pe'"></app-quicksight>
  </div>
</body>
